import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f2c5bcb8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "clearfix mg-b--15"
};
const _hoisted_2 = {
  key: 0,
  class: "cms-module-title--normal float--left mg-b--0"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-title fs--18 mg-r--5"
}, null, -1));

const _hoisted_4 = {
  class: "float--right"
};
const _hoisted_5 = {
  key: 0,
  class: "table-column-option-btn"
};
const _hoisted_6 = {
  class: "table-warp"
};
const _hoisted_7 = {
  class: "pagination__container mg-t--15"
};
import { ref, nextTick } from 'vue';
import Column from './Column.vue';
import Buttons from '@/components/Buttons/index.vue';
import { getTextWidth } from '@/utils';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import { onUnmounted } from 'vue';
const __default__ = {
  name: 'CommonTable',
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    render: {
      type: Function
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    columnConfig: {
      type: Object,
      default: {}
    },
    paginationConfig: {
      type: Object,
      default: () => ({})
    },
    // 翻页信息
    page: {
      type: Object,
      default: () => ({
        page: 1,
        limit: 10,
        totalNum: 0 // 总条数

      })
    },
    // 是否显示翻页
    showPagination: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: {
        loading: false // 显示loading效果

      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    rowSelectIndex: {
      type: Number,
      default: -1
    },
    dynamicOption: {
      type: Boolean,
      default: false
    },
    // 是否显示过滤筛选列按钮
    showColumnOptions: {
      type: Boolean,
      default: true
    },
    optionColumnList: {
      type: Array,
      default: () => []
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    pageSizesConfig: {
      type: Array,
      default: [10, 20, 40, 100]
    },
    // 动态图标最高高度，设置了之后100条数据都显示在一页，固定表头
    dynamicTableMaxHeight: {
      type: Boolean,
      default: false
    },
    extraHeight: {
      type: Number,
      default: 0
    }
  },
  emits: ['set-options-btn-column-width', 'row-click', 'selection-change', 'current-change', 'size-change', 'sort-change', 'cell-dblclick', 'expand-change'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const commonTableRef = ref(null);

    const handleRowClick = (row, col, event) => {
      emit('row-click', row, col, event);
    };

    const handleSizeChange = val => {
      props.paginationConfig.page = 1;
      props.paginationConfig.limit = val;
      props.render && props.render();
      emit('size-change', val);
    };

    const handlePagination = val => {
      props.paginationConfig.page = val;
      props.render && props.render();
      emit('current-change', val);
    };

    const handleSelectionChange = val => {
      emit('selection-change', val);
    };

    const handleSortChange = column => {
      emit('sort-change', column);
    };

    const handleDbclick = (row, column, cell, event) => {
      emit('cell-dblclick', row, column, cell, event);
    };

    const handleExpandChange = (row, expanded) => {
      emit('expand-change', row, expanded);
    };

    const isRowSelect = ({
      row,
      rowIndex
    }) => {
      row.index = rowIndex;
      return row.index === props.rowSelectIndex ? 'is-row-select row_no_focus' : 'row_no_focus';
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        commonTableRef.value && commonTableRef.value.doLayout();
      });
    };

    const setTableMaxHeight = () => {
      setTimeout(() => {
        const viewHeight = document.querySelector('.right__main');

        if (viewHeight && commonTableOutSideDiv.value) {
          tableMaxHeight.value = viewHeight.clientHeight - commonTableOutSideDiv.value.getBoundingClientRect().top - props.extraHeight;
        }
      });
    };

    watch(() => props.tableConfig.data, val => {
      if (val.length) {
        commonTableRef.value && commonTableRef.value.scrollTo(0, 0);

        if (props.dynamicOption) {
          setTimeout(() => {
            let minOptionsTextWidth = getTextWidth(t('操作'), {
              fontSize: '14px',
              fontWeight: 'bold'
            }) + 30;
            let btnList = document.querySelectorAll('.buttons__list');
            let maxWidthArr = [];
            let itemWidth = 0;
            btnList.length > 0 && btnList.forEach((item, index) => {
              let childText = '';

              if (item.children.length) {
                for (let i = 0; i < item.children.length; i++) {
                  childText = childText + item.children[i].innerText;
                }

                let width = getTextWidth(childText, {
                  fontSize: '14px'
                }) + 10 * item.children.length;
                itemWidth = width + 6 * item.children.length;
                maxWidthArr.push(itemWidth);
              }
            });
            let max = maxWidthArr.length ? Math.max.apply(null, maxWidthArr) + 14 : minOptionsTextWidth;
            emit('set-options-btn-column-width', max > minOptionsTextWidth ? max : minOptionsTextWidth);
            btnList = null;
          });
        }

        if (props.dynamicTableMaxHeight) {
          setTableMaxHeight();
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    const commonTableOutSideDiv = ref();
    const tableMaxHeight = ref(0);
    onMounted(() => {
      if (props.dynamicTableMaxHeight) {
        window.addEventListener('resize', setTableMaxHeight);
      }
    });
    onUnmounted(() => {
      if (props.dynamicTableMaxHeight) {
        window.removeEventListener('resize', setTableMaxHeight);
      }
    });
    expose({
      commonTableRef
    });
    return (_ctx, _cache) => {
      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['basic__table', {
          'cms-card-block': __props.tableConfig.isCardBlock ?? true,
          'dynamicmaxheight__table': __props.dynamicTableMaxHeight ?? true
        }])
      }, [__props.tableConfig?.isShowHeader ?? true ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.showTitle ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createTextVNode(" " + _toDisplayString(__props.tableConfig.listName ? _ctx.$t(__props.tableConfig.listName) : _ctx.$t('数据列表')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "headerBtnSlot"), _createVNode(Buttons, {
        buttonsList: __props.tableConfig.headerButtonsList
      }, null, 8, ["buttonsList"]), __props.showColumnOptions && __props.optionColumnList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_TableColumnOptionBtn, {
        "column-list": __props.optionColumnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        ref_key: "commonTableOutSideDiv",
        ref: commonTableOutSideDiv
      }, [_withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
        class: __props.dynamicOption ? 'dynamicOption' : '',
        ref_key: "commonTableRef",
        ref: commonTableRef,
        "row-class-name": isRowSelect,
        onRowClick: handleRowClick,
        border: ""
      }, __props.tableConfig, {
        "header-row-class-name": "color--table",
        onSelectionChange: handleSelectionChange,
        onSortChange: handleSortChange,
        onCellDblclick: handleDbclick,
        onExpandChange: handleExpandChange,
        "tooltip-effect": "light",
        "max-height": __props.dynamicTableMaxHeight ? tableMaxHeight.value : __props.tableConfig.maxHeight || 'auto'
      }), {
        default: _withCtx(() => [_createVNode(Column, _normalizeProps(_guardReactiveProps(__props.columnConfig)), null, 16), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 16, ["class", "max-height"])), [[_directive_loading, __props.options.loading]]), _renderSlot(_ctx.$slots, "tableunder")], 512), _withDirectives(_createElementVNode("div", _hoisted_7, [__props.showPagination ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        onSizeChange: handleSizeChange,
        onCurrentChange: handlePagination,
        "current-page": __props.paginationConfig.page || 1,
        "page-sizes": __props.pageSizesConfig,
        "page-size": __props.paginationConfig.limit || 10,
        total: Number(__props.paginationConfig.total) || 0,
        layout: __props.layout
      }, null, 8, ["current-page", "page-sizes", "page-size", "total", "layout"])) : _createCommentVNode("", true)], 512), [[_vShow, __props.tableConfig?.showPageBar ?? true]]), _renderSlot(_ctx.$slots, "footer")])], 2);
    };
  }

});